export default __webpack_public_path__ + "static/media/NFTY.f0cc4fcf.png";